module.exports = __webpack_public_path__ + "static/media/carb-circle.f501e4db.png";